import React, { useState } from 'react';

import { TimePicker } from 'Components/organisms/TimePicker';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function TimePickerComponents() {
  const [part, setPart] = useState(true);
  const [inputexist, setInputexist] = useState(true);
  const [time, setTime] = useState(undefined);
  return (
    <div className={cx('time-picker')}>
      <button onClick={() => setPart(!part)}>
        <span style={{ fontWeight: part && 700 }}>12시간</span>/
        <span style={{ fontWeight: !part && 700 }}>24시간</span>
      </button>
      <br />
      <button onClick={() => setInputexist(!inputexist)}>
        input<span style={{ fontWeight: inputexist && 700, paddingLeft: '5px' }}>여</span>/
        <span style={{ fontWeight: !inputexist && 700 }}>부</span>
      </button>
      <TimePicker
        use12Hours={part}
        inputexist={inputexist}
        ChangeHandler={(value) => setTime(value)}
        timeValue={11}
        TimeFormat={'a hh시 mm분'}
        mobileSetTime={false}
      />
    </div>
  );
}
export default TimePickerComponents;

export const path = '/time_picker';
